<div class="col-12">
    <div class="fatca-pep">
        <div class="container">
            <div class="row">
                <div class="fatca-pep__header">
                    <div class="row">
                        <div class="col-12">
                            <h3>We will need to collect data for you to continue.</h3>
                        </div>
                    </div>
                </div>
                <div class="fatca-pep__body">
                    <div class="row">
                        <h2>FATCA Information</h2>
                        <p>If none of the above options apply, please check the 'I am not a U.S. person' box.</p>
                        <div class="col-12 col-lg-6 fatca-pep__options fatca-pep__options--gray">
                            <input style="display:none;" #notUS type="checkbox"  (change)="notUSPerson($event)"/>
                            <button #button type="button" class="f-button--link btn-ico" (click)="notUS.click()">
                                <span [ngClass] = 'isUSPerson? "ico-uncheckbox" : "ico-green-checkbox"' class="atram-ico"></span>
                             </button>
                             <span class="text">I am not a US Person / I do not have any US Indicators</span>
                        </div>
                        <div class="fatca-pep__form">
                            <form [formGroup]="usFormGroup" [ngClass] = 'isUSPerson? "" : "fatca-pep__disabled"'>
                                <ng-container formArrayName="usArray">
                                    <ng-container *ngFor="let item of usArray.controls; let i = index">
                                        <div class="row" formGroupName="{{i}}">
                                            <div class="col-12 col-sm-6 fatca-pep__options fatca-pep__options">
                                                <input style="display:none;" type="checkbox" />
                                                <button #button formControlName="usID" type="button" class="f-button--link btn-ico" (click)="item.value.usAnswer = !item.value.usAnswer" [attr.disabled]="isUSPerson? null: 'true'">
                                                    <span [ngClass] = 'item.value.usAnswer? "ico-green-checkbox" : "ico-uncheckbox"' class="atram-ico"></span>
                                                    </button>
                                                    <span class="text">{{item.value.usText}}</span>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </form>
                        </div>
                        <h2>Political Exposure</h2>
                        <p>If none of these apply to you, leave them unchecked.</p>
                        <div class="col-12 col-lg-9 fatca-pep__options fatca-pep__options--gray">
                            <input style="display:none;" #notUS type="checkbox" />
                            <button #button type="button" class="f-button--link btn-ico" (click)="isPEPPerson = !isPEPPerson">
                                <span [ngClass] = 'isPEPPerson? "ico-green-checkbox" : "ico-uncheckbox"' class="atram-ico"></span>
                             </button>
                             <span class="text">I am currently a Politically Exposed Person (PEP)/have been a PEP within the last 3 years</span>
                        </div>
                        <div class="col-12 fatca-pep__form" *ngIf="isPEPPerson">
                            <div class="row">
                                <div class="f-form_input col-12 col-sm-4 fatca-pep__field">
                                    <atram-select [parentFormGroup]="PEPFormGroup"
                                                    type="text"
                                                    controlName="govAgency"
                                                    label="Government Agency"
                                                    placeholder="Government Agency"    
                                                    [isRequired]="true"
                                                    [options]="usOptions">
                                    </atram-select>
                                </div>
                                <div class="f-form_input col-12 col-sm-4 fatca-pep__field">
                                    <atram-select [parentFormGroup]="PEPFormGroup"
                                                    type="text"
                                                    controlName="position"
                                                    label="Position"
                                                    placeholder="Position"    
                                                    [isRequired]="true"
                                                    [options]="usOptions">
                                    </atram-select>
                                </div>
                                <div class="f-form_input col-12 col-sm-4 fatca-pep__field">
                                    <atram-textbox [parentFormGroup]="PEPFormGroup"
                                                    type="text"
                                                    controlName="yearsOfService" 
                                                    label="Years of Service"
                                                    [showPhNumber]="false"
                                                    placeholder="Years of Service"
                                                    [isError]="(!PEPFormGroup.get('yearsOfService')?.valid && PEPFormGroup.get('yearsOfService')?.touched)"
                                                    [isRequired]="true">
                                    </atram-textbox>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-7 fatca-pep__options fatca-pep__options--gray">
                            <input style="display:none;" #notUS type="checkbox" />
                            <button #button type="button" class="f-button--link btn-ico" (click)="isPEPRelated = !isPEPRelated">
                                <span [ngClass] = 'isPEPRelated? "ico-green-checkbox" : "ico-uncheckbox"' class="atram-ico"></span>
                             </button>
                             <span class="text">I have an immediate family member who is a Politically Exposed Person</span>
                        </div>
                        <div class="col-12 fatca-pep__form" *ngIf="isPEPRelated">
                            <div class="row">
                                <div class="f-form_input col-12 col-sm-8 fatca-pep__field">
                                    <atram-textbox [parentFormGroup]="PEPRelativeFormGroup"
                                                    type="text"
                                                    controlName="relativeName" 
                                                    label="Full Name of Relative"
                                                    [showPhNumber]="false"
                                                    placeholder="Full Name of Relative"
                                                    [isError]="(!PEPRelativeFormGroup.get('relativeName')?.valid && PEPRelativeFormGroup.get('relativeName')?.touched)"
                                                    [isRequired]="true">
                                    </atram-textbox>
                                </div>
                                <div class="f-form_input col-12 col-sm-4 fatca-pep__field">
                                    <atram-textbox [parentFormGroup]="PEPRelativeFormGroup"
                                                    type="text"
                                                    controlName="relationship" 
                                                    label="Relationship"
                                                    [showPhNumber]="false"
                                                    placeholder="Relationship"
                                                    [isError]="(!PEPRelativeFormGroup.get('relationship')?.valid && PEPRelativeFormGroup.get('relationship')?.touched)"
                                                    [isRequired]="true">
                                    </atram-textbox>
                                </div>
                                <div class="f-form_input col-12 col-sm-8 fatca-pep__field">
                                    <atram-textbox [parentFormGroup]="PEPRelativeFormGroup"
                                                    type="text"
                                                    controlName="position" 
                                                    label="Position"
                                                    [showPhNumber]="false"
                                                    placeholder="Position"
                                                    [isError]="(!PEPRelativeFormGroup.get('position')?.valid && PEPRelativeFormGroup.get('position')?.touched)"
                                                    [isRequired]="true">
                                    </atram-textbox>
                                </div>
                                <div class="f-form_input col-12 col-sm-4 fatca-pep__field">
                                    <atram-textbox [parentFormGroup]="PEPRelativeFormGroup"
                                                    type="text"
                                                    controlName="yearsOfService" 
                                                    label="Years of Service"
                                                    [showPhNumber]="false"
                                                    placeholder="Years of Service"
                                                    [isError]="(!PEPRelativeFormGroup.get('yearsOfService')?.valid && PEPRelativeFormGroup.get('yearsOfService')?.touched)"
                                                    [isRequired]="true">
                                    </atram-textbox>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="fatca-pep__options">
                        <p></p>
                    </div> -->
                </div>
                <div class="col-12">
                    <div class="buttons buttons--dual">
                        <div class="row">
                            <div class="buttons__first col-12 col-sm-6">
                                <atram-button buttonType="default"
                                    label="Back"
                                    componentClass="btn-submit"
                                    (on-click)="goBack()">
                                </atram-button>
                            </div>
                            <div class="col-12 col-sm-6">
                                <atram-button label="Next Page"
                                    componentClass="btn-submit"
                                    (on-click)="proceed()">
                                </atram-button>  
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>